<template>
    <img src="/images/logo.png" class="mr-2"/>
</template>
